<template lang="pug">
div
    grid-table-component(
        :headers='headers',
        :data='paginacao.regioes',
        :is-paginated='true',
        :is-loading='isLoading',
        :pagination='setPagination()',
        @table:page-changed='checkPaginationChange($event)'
    )

        template(v-slot:dataCadastro='props')
            span {{ props.item.dataCadastro | data }}

        template(v-slot:acao='props')
            dropdown-component(
                :list='props.item.acao'
                @input="onAction($event, props.item)"
                :is-select='false'
                position='left'
            )
    modal-component(
        v-if='modalVisualizacaoRegiao',
        title='Visualizar região de análise',
        @close='modalVisualizacaoRegiao = false'
    )
        VisualizarRegiaoModal(:regiao="selectedRegiao")

    modal-component(
        v-if='modalDeleteRegiao',
        title='Confirmação de exclusão de região ?',
        @close='modalDeleteRegiao = false'
    )
        DeleteRegiaoModal(:regiao="selectedRegiao", @cancelar='cancelarExcluir($event)')

    modal-component(
        v-if='modalVinculaGerente',
        title='Vincular gerente operacional',
        @close='modalVinculaGerente = false'
    )
        ModalVinculacaoGO(:regiao-id="selectedRegiao.id", @cancelar='cancelarVincular($event)')
</template>

<script>
import DeleteRegiaoModal from './DeleteRegiaoModal.vue';
import VisualizarRegiaoModal from './VisualizarRegiaoModal.vue';
import ModalVinculacaoGO from './ModalVinculacaoGO.vue';

export default {

    name: 'RegiaoAnaliseTableComponent',

    components: {
        DeleteRegiaoModal,
        ModalVinculacaoGO,
        VisualizarRegiaoModal
    },

    props: {
        headers: {
            type: Array,
            default: null,
        },

        data: {
            type: Array,
            default: null,
        },

        paginacao: {
            type: Object,
            default: () => ({
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                regioes: [],
            }),
        },

        isLoading: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            modalVisualizacaoRegiao: false,
            modalDeleteRegiao: false,
            modalVinculaGerente: false,
            selectedRegiao: null
        };
    },

    methods: {

        onAction(event, regiao) {
            this.selectedRegiao = regiao;
            if (event.id === 'VINCULAR_GO') {
                this.modalVinculaGerente = true;
            }
            if (event.id === 'EXCLUIR') {
                this.modalDeleteRegiao = true;
            }
            if (event.id === 'VISUALIZAR') {
                this.modalVisualizacaoRegiao = true;
            }
            if (event.id === 'EDITAR') {
                this.$router.push({ path: '/regiao/' + this.selectedRegiao.id })
            }
        },

        checkPaginationChange(event) {
            let newPage = {
                total: event.totalItems,
                pagina: event.page,
                numeroPaginas: event.totalPages,
                quantidadePagina: event.itemsPerPage
            }

            this.$emit('inbox:page-change', newPage);
        },

        setPagination() {

            let pagination = {
                page: this.paginacao.pagina,
                totalPages: this.paginacao.numeroPaginas,
                itemsPerPage: this.paginacao.quantidadePagina,
                totalItems: this.paginacao.total,
                order: 'ASC'
            };

            return pagination;
        },

        cancelarVincular(event) {
            this.modalVinculaGerente = !event;
        },

        cancelarExcluir(event) {
            this.modalDeleteRegiao = !event;
        }

    },
};
</script>
